import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import navbarimage from "assets/img/layout/Navbar.png";
import { BsArrowBarUp } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdNotificationsOutline, IoMdSettings } from "react-icons/io";
import { CiGlobe } from "react-icons/ci";
import { Button, Box, Modal, Typography } from "@mui/material";
import axios from "axios";
import { UI_VERSION } from "../../version";
import { API_VERSION } from "../../version";
import { clearSession, readStoredJson, readUser } from "utils/session";
import AccountImage from "components/AccountImage";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  background: "#ffffff",
  borderRadius: "6px",
  border: "none",
  color: "#858585",
  p: 4,
};

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const navigate = useNavigate();

  const loc = readUser();
  const [notifications, setNotifications] = useState([]);

  const loadNotifications = () => {
    const storedNotifs = readStoredJson("temp_notifications", []);
    setNotifications(Array.isArray(storedNotifs) ? storedNotifs : []);
  };

  // Load on mount and listen for new ones
  useEffect(() => {
    loadNotifications();
    window.addEventListener("new-fcm-notification", loadNotifications);
    return () => window.removeEventListener("new-fcm-notification", loadNotifications);
  }, []);

  // Function to clear them all
  const clearNotifications = () => {
    localStorage.removeItem("temp_notifications");
    setNotifications([]);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

const logoutHandle = async () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const fcmToken = localStorage.getItem("fcmToken");

    // 1. If we have a token, attempt to deregister it from the backend
    if (loc && loc.token && fcmToken) {
      try {
        await axios.post(
          `${apiBaseUrl}/api/firebase/deregister-device`,
          { fcm_token: fcmToken },
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${loc.token}`,
            },
          }
        );
      } catch (error) {
        console.error("Failed to deregister FCM token, but proceeding with logout.", error);
      }
    }

    clearSession();
    setOpen(false);
    navigate("/");
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            textAlign="center"
            component="h2"
          >
            Are you sure want to Logout
          </Typography>
          <Box sx={{ justifyContent: "center", display: "flex" }}>
            <Button onClick={logoutHandle} className="text-red-500">
              Yes
            </Button>
            <Button onClick={() => setOpen(false)}>No</Button>
          </Box>
        </Box>
      </Modal>

      <div className="ml-[6px]">
        {/* <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div> */}
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[465px] xl:gap-2">
        <div className="mr-3 flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start language */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <CiGlobe className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <a
                target="blank"
                href="https://hypertrace.io"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-[11px] font-bold text-white transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                See more products & solutions
              </a>
              <a
                target="blank"
                href="https://play.google.com/store/apps/details?id=com.hypertrace.app"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
              >
                Download for Android
              </a>
              <a
                target="blank"
                href="https://play.google.com/store/apps/details?id=com.hypertrace.app"
                className="hover:bg-black px-full linear flex cursor-pointer items-center justify-center rounded-xl py-[11px] font-bold text-navy-700 transition duration-200 hover:text-navy-700 dark:text-white dark:hover:text-white"
              >
                Download for iOS
              </a>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />
        {/* start language */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdSettings className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              {/* Version Display Block */}
              <div className="px-full linear flex cursor-default items-center justify-between rounded-xl bg-gray-100 px-4 py-[11px] font-bold text-navy-700 dark:bg-navy-900 dark:text-white">
                <span>UI Version</span>
                <span className="text-brand-500 dark:text-brand-400">{UI_VERSION}</span>
              </div>

              {/* Placeholder for future settings */}
              <div
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
              >
                System Status (Coming Soon)
              </div>
              
              <div
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
              >
                Clear Local Cache
              </div>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />

        {/* start Notification */}
        <Dropdown
          button={
            <div className="relative cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
              {/* Notification Badge */}
              {notifications.length > 0 && (
                <span className="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
                  {notifications.length}
                </span>
              )}
            </div>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
                <p 
                  className="cursor-pointer text-sm font-bold text-navy-700 hover:underline dark:text-white"
                  onClick={clearNotifications}
                >
                  Mark all read
                </p>
              </div>

              {/* Dynamic Notifications List */}
              <div className="flex max-h-[300px] flex-col gap-3 overflow-y-auto pr-2">
                {notifications.length > 0 ? (
                  notifications.map((notif) => (
                    <button key={notif.id} className="flex w-full items-center">
                      <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                        <BsArrowBarUp />
                      </div>
                      <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                        <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                          {notif.title}
                        </p>
                        <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                          {notif.body}
                        </p>
                        <p className="mt-1 text-left text-[10px] text-gray-500 dark:text-gray-400">
                          {notif.time}
                        </p>
                      </div>
                    </button>
                  ))
                ) : (
                  <div className="py-4 text-center text-sm text-gray-500 dark:text-gray-400">
                    No new notifications
                  </div>
                )}
              </div>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <AccountImage
              className="h-10 w-10 cursor-pointer rounded-full object-cover"
              alt="profile"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {loc?.customerName || "there"}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                {/* <div className="text-sm text-gray-800 dark:text-white hover:dark:text-white cursor-pointer">
                  Profile Settings
                </div> */}
                <div className=" cursor-pointer text-sm text-gray-800 dark:text-white hover:dark:text-white">
                  Newsletter Settings
                </div>
                <div
                  className="mt-3 cursor-pointer text-sm font-medium text-red-500 transition duration-150 ease-out hover:text-red-500 hover:ease-in"
                  onClick={handleOpen}
                >
                  Log Out
                </div>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
